import { examplesRootPath } from '../hooks/useInitialState'

export const buildImplementationSearchUrl = (gameIds: string[]) => {
  return examplesRootPath + (gameIds.length ? '/games/' + gameIds.join(',') : '/')
}
